import { UserRole, UserRoleGroup } from '@portal/entity-services/interfaces';

export type RoleEditPermissionMatrix = {
  [key in UserRole]?: UserRole[];
};

export type RolesByGroup = {
  [key in UserRoleGroup]?: UserRole[];
};
